export enum ScheduleKind {
    MESSAGE = 'MESSAGE',
    MUSIC = 'MUSIC',
    SCENT = 'SCENT',
    VIDEO = 'VIDEO'
};

export enum ScheduleInnerMixing {
    ALTERNATED = 'ALTERNATED',
    CHAINED = 'CHAINED',
    WEIGHTED = 'WEIGHTED'
};

export enum ScheduleOuterMixing {
    CHAINED = 'CHAINED',
    DISTRIBUTED = 'DISTRIBUTED',
    EXCLUSIVE = 'EXCLUSIVE',
    MIXED = 'MIXED'
};

export enum EventStrategy {
    DELETE = 'DELETE',
    UNSCHEDULE = 'UNSCHEDULE'
};

export enum EventAttachment {
    PLANNING = 'PLANNING',
    SPOT = 'SPOT',
    UNATTACHED = 'UNATTACHED'
};